import React, { Component } from 'react'
import styles from './Home.module.css';
import Slider from '../../containers/Slider/Slider';

export default class Home extends Component {
  render() {
    return (
      <div className={styles.Home}>
        <Slider />
      </div>
    )
  }
}
